import type { LogEntry } from '@/types/log-entry';

export { SCOUTING_TAGS } from '@/types/log-entry';
export type { ScoutingTag } from '@/types/log-entry';
export { formatTagLabel } from '@/utils/format-utils';

export const ANIMAL_SEX_OPTIONS = ['buck', 'doe', 'fawn', 'unknown'] as const;
export type AnimalSex = (typeof ANIMAL_SEX_OPTIONS)[number];

export const ANIMAL_BEHAVIOR_OPTIONS = [
  'feeding',
  'traveling',
  'chasing',
  'bedded',
  'standing',
  'other',
] as const;
export type AnimalBehavior = (typeof ANIMAL_BEHAVIOR_OPTIONS)[number];

export function formatAnimalSummary(entry: LogEntry): string | null {
  if (!entry.animalObserved) return null;

  const parts: string[] = [];

  const sex = entry.animalSex;
  const antler = entry.animalAntlerDescription;

  if (sex) {
    const sexLabel = sex.charAt(0).toUpperCase() + sex.slice(1);
    if (sex === 'buck' && antler) {
      parts.push(`${sexLabel} — ${antler}`);
    } else {
      parts.push(sexLabel);
    }
  }

  if (entry.animalAgeClass) {
    parts.push(entry.animalAgeClass);
  }

  if (entry.animalBehavior) {
    parts.push(entry.animalBehavior);
  }

  if (parts.length === 0) return 'Animal observed';
  return parts.join(', ');
}
